module.exports = __webpack_public_path__ + "static/media/edit-profile.2123ca14.svg";